import { NgModule } from '@angular/core';
import { SmoothScrollDirective } from './smooth-scroll.directive';
import { InputValidator } from './input-validator.directive';
import { SlotDefaultDirective } from './slot-default.directive';
import { SlotMarkerDirective } from './slot-marker.directive';
import { ClickListenerDirective } from './click-listener.directive';

@NgModule({
	declarations: [SmoothScrollDirective, InputValidator, SlotDefaultDirective, SlotMarkerDirective, ClickListenerDirective],
	exports: [SmoothScrollDirective, InputValidator, SlotDefaultDirective, SlotMarkerDirective, ClickListenerDirective]
})
export class WmDirectivesModule {}
